import { render, staticRenderFns } from "./WidgetsWidget.vue?vue&type=template&id=a6f1abb8&scoped=true"
import script from "./WidgetsWidget.vue?vue&type=script&lang=js"
export * from "./WidgetsWidget.vue?vue&type=script&lang=js"
import style0 from "./WidgetsWidget.vue?vue&type=style&index=0&id=a6f1abb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f1abb8",
  null
  
)

export default component.exports